import moment from "moment";
import { useState, useEffect } from "react";
import {
  myTasks5WayListName,
  myTasksSDCA5WayListName,
} from "src/api/config/myTasks5Way.config";
import { myTaskActionsListName } from "src/api/config/myTasksActions.config";
import { myTasks5WayStatusesListName } from "src/api/config/myTasksLists.config";
import Loading from "src/components/Loading";
import { getItemsRequest, updateItemRequest } from "src/modules/spItems/api";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { TooltipItem } from "src/utils/Tooltip";
import { twMerge } from "tailwind-merge";
import { Statuses5WayNotice } from "../statusesNotice/statusesNotice";
import { emailsSender, paramsListName, siteUrl } from "src/api/config";
import { emailAPI } from "src/utils/api.utils";
import { useAppSelector } from "src/hooks/redux";
import { selectUsers } from "src/modules/users/selector";
import { selectItems } from "src/modules/spItems/selectors";
import {
  actionsStatus,
  fiveWhyStatus,
  FiveWhyType,
} from "src/api/config/systemSwitch";
import { mode } from "src/constants";
import _ from "lodash";
const { sendEmail } = emailAPI();

const Statuses = ({ card5WayID }: any) => {
  const [statuses, setStatuses] = useState<any>([]);
  const [card5Way, setCard5Way] = useState<any>(null);
  const [sdcaItems, setSdcaItems] = useState<any>([]);
  const [actions, setActions] = useState<any>([]);
  const [status, setStatus] = useState<any>(null);
  const [card5WayTree, setCard5WayTree] = useState<any>([]);
  const [getAll, setGetAll] = useState(false);
  const users: any = useAppSelector(selectUsers);
  const daysParams: any = useAppSelector((state) =>
    selectItems(state, paramsListName)
  );

  useEffect(() => {
    getItemsRequest({ listName: myTasks5WayStatusesListName }).then(
      (results) => {
        setStatuses(results.items);
        getItemsRequest({
          listName: myTasks5WayListName,
          filters: { ID: card5WayID },
        }).then((results) => {
          setCard5Way(results.items.length > 0 && results.items[0]);
        });
      }
    );
  }, []);

  useEffect(() => {
    if (card5Way) {
      setCard5WayTree((card5Way.Tree && JSON.parse(card5Way.Tree)) || []);
      getItemsRequest({
        listName: myTasksSDCA5WayListName,
        filters: { _x0035_Way: card5WayID },
      }).then((results) => {
        setSdcaItems(results.items);
        let arrRequests: any = [];
        results.items.map((item) => {
          arrRequests = [
            ...arrRequests,
            getItemsRequest({
              listName: myTaskActionsListName,
              filters: {
                ImportantHashTag:
                  (card5Way.Type5Way === FiveWhyType &&
                    `#5Почему_${item.ID}*`) ||
                  `#Отчет_об_отклонениях_${item.ID}*`,
              },
            }),
          ];
        });
        arrRequests = [
          ...arrRequests,
          getItemsRequest({
            listName: myTaskActionsListName,
            filters: {
              ImportantHashTag:
                (card5Way.Type5Way === FiveWhyType &&
                  `#5Почему_${card5WayID}A*`) ||
                `#Отчет_об_отклонениях_${card5WayID}A*`,
            },
          }),
        ];
        if (arrRequests.length > 0) {
          Promise.all(arrRequests).then((values) => {
            let tempActions: any = [];
            values.map((value) => {
              tempActions = [...tempActions, ...value.items];
            });
            setActions([...tempActions]);
            setGetAll(true);
          });
        } else {
          setGetAll(true);
        }
      });
    }
  }, [card5Way]);

  useEffect(() => {
    if (getAll && daysParams.length > 0) {
      const sdcaItemsWithRoots = sdcaItems.filter(
        (sdcaItem) =>
          sdcaItem.RootTree &&
          card5WayTree.find(
            (treeItem) =>
              (treeItem.root || treeItem.system) &&
              treeItem.reason === sdcaItem.RootTree
          )
      );
      const days =
        (card5Way.Type5Way === FiveWhyType &&
          daysParams
            .find((param: any) => param.Key === "5Way")
            ["Value"].trim()) ||
        daysParams
          .find((param: any) => param.Key === "DeviationReport")
          ["Value"].trim();
      if (
        card5Way.Status &&
        (card5Way.Status.get_lookupId() === fiveWhyStatus.escalate ||
          card5Way.Status.get_lookupId() === fiveWhyStatus.cancel)
      ) {
        setStatus(
          statuses.find(
            (status: any) => status.ID === card5Way.Status.get_lookupId()
          )
        );
      } else if (
        card5WayTree.filter((treeItem: any) => treeItem.root || treeItem.system)
          .length > 0 &&
        sdcaItems.length > 0 &&
        actions.length > 0 &&
        actions.filter(
          (action: any) =>
            action.Status.get_lookupId() !== actionsStatus.cancel &&
            action.Status.get_lookupId() !== actionsStatus.closed
        ).length === 0 &&
        actions.filter(
          (action: any) =>
            action.Status.get_lookupId() === actionsStatus.closed &&
            action.ImportantHashTag.indexOf("A") === -1 &&
            sdcaItemsWithRoots.find((sdcaItem) =>
              action.ImportantHashTag.indexOf(`_${sdcaItem.ID}`)
            )
        ).length >= sdcaItemsWithRoots.length &&
        sdcaItemsWithRoots.every((item) =>
          actions
            .filter((action) => action.ImportantHashTag.indexOf("A") === -1)
            .some((action) =>
              new RegExp(`_${item.ID}(\\D|$)`).test(action.ImportantHashTag)
            )
        )
      ) {
        setStatus(
          statuses.find((status: any) => status.ID === fiveWhyStatus.closed)
        ); // Закрыто
      } else if (
        moment(card5Way.Date5Way)
          .add(Number(days), "days")
          .startOf("day")
          .unix() < moment(new Date()).startOf("day").unix() ||
        (moment(card5Way.Date5Way)
          .add(Number(days), "days")
          .startOf("day")
          .unix() >= moment(new Date()).startOf("day").unix() &&
          actions.filter(
            (action: any) => action.Status.get_lookupId() === actionsStatus.old
          ).length > 0)
      ) {
        setStatus(
          statuses.find((status: any) => status.ID === fiveWhyStatus.old)
        ); // Просрочено
      } else if (
        moment(card5Way.Date5Way)
          .add(Number(days), "days")
          .startOf("day")
          .unix() >= moment(new Date()).startOf("day").unix()
      ) {
        setStatus(
          statuses.find((status: any) => status.ID === fiveWhyStatus.process)
        ); // В процессе
      }
    }
  }, [getAll, daysParams]);

  useEffect(() => {
    if (status) {
      updateItemRequest({
        listName: myTasks5WayListName,
        body: {
          ID: card5WayID,
          Status: status.ID,
          ChangeStatusDate: new Date(),
        },
      }).then(() => {
        if (
          emailsSender &&
          status.ID === fiveWhyStatus.closed &&
          card5Way.Status.get_lookupId() !== fiveWhyStatus.closed
        ) {
          const timestamp = moment().unix();
          if (card5Way.Type5Way === FiveWhyType) {
            const emailBody = {
              Body: `Здравствуйте ${
                users[card5Way.AuthorEmail] &&
                users[card5Way.AuthorEmail]["displayName"]
              },<br/><br/>Примите к сведению, что 5Почему <a href="${siteUrl}/dashboard/3?5WayCard=${
                card5Way.ID
              }">${card5Way.Description.trim()}</a> был закрыт`,
              DateToBeSentAt: moment().subtract(12, "hours").toDate(),
              Title: "Мои Задачи | 5Почему закрыт",
              Subject: "Мои Задачи | 5Почему закрыт",
              Recepients: card5Way.AuthorEmail,
              CheckDoc: String(timestamp),
            };
            Promise.all([sendEmail(emailBody)]);
          } else {
            const emailBody = {
              Body: `Здравствуйте ${
                users[card5Way.AuthorEmail] &&
                users[card5Way.AuthorEmail]["displayName"]
              },<br/><br/>Примите к сведению, что Отчет об отклонении <a href="${siteUrl}/dashboard/3?deviationCard=${
                card5Way.ID
              }">${card5Way.Description.trim()}</a> был закрыт`,
              DateToBeSentAt: moment().subtract(12, "hours").toDate(),
              Title: "Мои Задачи | Отчет об отклонении закрыт",
              Subject: "Мои Задачи | Отчет об отклонении закрыт",
              Recepients: card5Way.AuthorEmail,
              CheckDoc: String(timestamp),
            };
            Promise.all([sendEmail(emailBody)]);
          }
        }

      });
    }
  }, [status]);

  return (
    <>
      {(!status && (
        <FlexCol className="h-[32px] w-[32px]">
          <Loading />
        </FlexCol>
      )) || (
        <TooltipItem
          wrapperClassName="w-[542px] flex justify-start"
          position="bottom-left"
          tooltipsReactNode={
            <Statuses5WayNotice type5Way={card5Way && card5Way.Type5Way} />
          }
          tooltipsText=""
        >
          <FlexRow
            style={{ backgroundColor: status.Color }}
            className={twMerge(
              `text-black py-[5px] px-[14px] rounded-md font-bold h-fit w-fit`
            )}
          >
            {status.Title}
          </FlexRow>
        </TooltipItem>
      )}
    </>
  );
};

export default Statuses;
